import request from '@teetsh/app/src/utils/request';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { USER_KEY } from '@teetsh/app/src/queries/user/useUser';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

export interface LoginRequestPayload {
  email: string;
  password: string;
}

export function useLogin() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['common']);
  const { mutateAsync } = useMutation<
    { token: string },
    AxiosError,
    LoginRequestPayload
  >({
    mutationFn: ({ email, password }) => {
      const form = new FormData();
      form.append('email', email);
      form.append('password', password);
      return request('/login', {
        method: 'POST',
        body: form,
      });
    },

    onSuccess: (response, v) => {
      localStorage.setItem('id_token', response.token);
      localStorage.setItem('email', v.email);

      queryClient.invalidateQueries({
        queryKey: [USER_KEY],
      });
    },
    retry: (failCount, err) => {
      if (err?.response?.status === 401) {
        return false;
      }
      return failCount < 1;
    },
    onError: err => {
      if (err?.response?.status !== 401) {
        notifyError({
          timeout: 19000,
          title: t('common:messages.genericErrorLong'),
        });
      }
    },
  });
  return mutateAsync;
}
